import { AppState } from 'Features/App/store';
import { DICTIONARIES_SLICE } from '../dictionariesSlice';

export const datasourceStatusesSelector = (state: AppState) => state[DICTIONARIES_SLICE].datasourceStatuses;
export const datasourceStatusSelector = (datasourceId: number) => (state: AppState) => {
  return state[DICTIONARIES_SLICE].datasourceStatuses[datasourceId];
};
export const datasourceStatusEnabledModeSelector = (datasourceId: number) => (state: AppState) => {
  return state[DICTIONARIES_SLICE].datasourceStatuses[datasourceId]?.enableMode;
};
export const datasourceStatusDangerModeSelector = (datasourceId: number) => (state: AppState) => {
  return state[DICTIONARIES_SLICE].datasourceStatuses[datasourceId]?.dangerMode;
};

export const datasourceStatusStormModeSelector = (datasourceId: number) => (state: AppState) => {
  return state[DICTIONARIES_SLICE].datasourceStatuses[datasourceId]?.stormMode;
};
export const datasourceStatusSoftReleaseModeSelector = (datasourceId: number) => (state: AppState) => {
  return state[DICTIONARIES_SLICE].datasourceStatuses[datasourceId]?.softRelease;
};
export const datasourceStatusDataReceivedSelector = (datasourceId: number) => (state: AppState) => {
  return state[DICTIONARIES_SLICE].datasourceStatuses[datasourceId]?.dataReceived;
};
